import InnerHTML from 'dangerously-set-html-content';

export const StyledCustom = (props: StyledCustomProps) => {
    const { id, bleed, content } = props;
    return <Custom id={id} bleed={bleed === 'on'} content={content} />;
};

interface StyledCustomProps {
    id: string;
    bleed: 'on' | 'off';
    content: string;
}

export const Custom = (props: CustomProps) => {
    const { id, bleed = false, content } = props;

    if (!content) {
        return null;
    }

    return (
        <div id={id} className={bleed ? 'bleed' : undefined}>
            <InnerHTML html={content} />
        </div>
    );
};

interface CustomProps {
    id: string;
    bleed: boolean;
    content: string;
}
